import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, isRef as _isRef, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue"

import FilterablePopover from "~/core-ui/vue/ui/FilterablePopover.vue";
import PopoverMenuItem from "~/core-ui/vue/ui/popover-menu/PopoverMenuItem.vue";
import PopoverMenu from "~/core-ui/vue/ui/popover-menu/PopoverMenu.vue";
import {computed, ref} from "vue";


import {defineComponent} from 'vue';

const __default__ = defineComponent({
    name: "LanguagePopover"
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: /*@__PURE__*/_mergeModels({
    languages: {}
  }, {
    "modelValue": { type: Boolean, ...{
    default: false,
} },
    "modelModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["select"], ["update:modelValue"]),
  setup(__props: any, { emit: __emit }) {

let props = __props;

let emits = __emit;

let model = _useModel<boolean>(__props, "modelValue");

let languageToDisplay = computed(() => {
    let result = props.languages;
    if (languageFilter.value) {
        let filter = languageFilter.value.toLowerCase();
        result = result.filter(result => result.descr.toLowerCase().includes(filter));
    }
    return result;
});

let languageFilter = ref<string>(null);

async function selectLanguage(languageId: string) {
    model.value = false;
    emits("select", languageId);
}

return (_ctx: any,_cache: any) => {
  const _component_el_popover = _resolveComponent("el-popover")!

  return (_openBlock(), _createBlock(_component_el_popover, {
    visible: _unref(model),
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => (_isRef(model) ? (model).value = $event : model = $event)),
    trigger: "click",
    "popper-class": "p-0"
  }, {
    reference: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    default: _withCtx(() => [
      (_unref(model))
        ? (_openBlock(), _createBlock(FilterablePopover, {
            key: 0,
            modelValue: _unref(languageFilter),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(languageFilter) ? (languageFilter).value = $event : languageFilter = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(PopoverMenu, null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(languageToDisplay), (language) => {
                    return (_openBlock(), _createBlock(PopoverMenuItem, {
                      key: language.id,
                      onClick: ($event: any) => (selectLanguage(language.id))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(language.descr), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }, 8, ["visible"]))
}
}

})